// extracted by mini-css-extract-plugin
module.exports = {"image":"image--UpgradeToPro-paywalls-components__2oa5Z","description":"description--UpgradeToPro-paywalls-components__2U8pz"};